import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart(state, action) {
      state.cart.push(action.payload);
    },
    clearCart(state, action) {
      state.cart = [];
    },
    removeMovie(state, action) {
      state.cart = state.cart.filter((movie) => movie.id !== action.payload);
    },
  },
});

export const { addToCart, clearCart, removeMovie } = cartSlice.actions;
export default cartSlice.reducer;
